// Auto generated file, do not manually modify!
// com.hotpads.cometuserauthdtos.clientauth.ProfileType

export enum ProfileType {
  AGENT = 'AGENT',
  LANDLORD = 'LANDLORD',
  PROPERTY_MANAGER = 'PROPERTY_MANAGER',
  REAL_ESTATE_INVESTOR = 'REAL_ESTATE_INVESTOR',
}

export const ProfileType_values = [
  ProfileType.AGENT,
  ProfileType.LANDLORD,
  ProfileType.PROPERTY_MANAGER,
  ProfileType.REAL_ESTATE_INVESTOR,
] as const;
